<template>
  <div class="wrapper perfect-theme-design">
    <div class="content">
      <div class="title">
        <div>
          <!-- <span class="require">*</span> -->
          必备品/排面数
        </div>
        <div v-if="!isDetailPage">
          <el-button
            type="primary"
            plain
            v-if="employeeLevel > 50"
            @click="handleAddRow()"
            >新增</el-button
          >
          <el-button type="warning" plain @click="handleReset()"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <div v-if="mandatoryItemList.length">
      <div class="info">
        <el-row class="header" type="flex" align="middle" justify="center">
          <el-col :span="employeeLevel > 50 ? 4 : 10">套餐名称</el-col>
          <el-col :span="6" v-if="employeeLevel > 50">
            开放区域
          </el-col>
          <el-col :span="24">
            <el-col :span="3">品牌</el-col>
            <el-col :span="3">子品牌</el-col>
            <el-col :span="3">容量</el-col>
            <el-col :span="3">是否多联包</el-col>
            <el-col :span="3">规格</el-col>
            <el-col :span="3">最小陈列件</el-col>
            <el-col :span="2">排面数</el-col>
            <el-col :span="4">操作</el-col>
          </el-col>
        </el-row>

        <el-row
          style="overflow:auto"
          v-for="(mandatory, index) in mandatoryItemListPagination"
          :key="index"
          class="detail"
          type="flex"
          align="middle"
          justify="end"
        >
          <!-- <el-col :span="4">{{ mandatory.defineName }} </el-col> -->
          <el-col :span="7" style="display: flex; align-items: center">
            <el-col :span="employeeLevel > 50 ? 12 : 24">
              <el-tooltip
                effect="light"
                :content="mandatory.defineName"
                placement="top"
                :disabled="employeeLevel > 50"
              >
                <el-input
                  v-model="mandatory.defineName"
                  clearable
                  filterable
                  placeholder="请输入套餐名称"
                  :disabled="!mandatory.canUpdate && (disabledSelected || isDetailPage)"
                  @change="everyCheckData()"
                  @blur="checkName"
                  :style="employeeLevel > 50 ? 'width:120px' : 'width:190px'"
                />
              </el-tooltip>
            </el-col>
            <!-- 选择区域 -->
            <el-col :span="12" v-if="employeeLevel > 50">
              <div class="region-wrapper">
                <div style="margin-bottom: 10px">
                  <el-checkbox-button v-model="mandatory.checkAll"
                    @change="handleCheckAllChange($event, mandatory)"
                  >
                    {{ mandatory.checkAll ? "取消全选" : "全选" }}
                  </el-checkbox-button>
                </div>
                <el-checkbox-group v-model="mandatory.regionCodeList"
                  @change="handleRegionChange($event, mandatory)"
                >
                  <el-checkbox-button
                    v-for="item in regionListByBu"
                    :label="item.orgCode"
                    :key="item.orgId"
                    :disabled="!item.canUpdate && $route.query.class === 'detail'"
                  >
                    {{ item.orgName.split('|')[0] }}
                  </el-checkbox-button>
                </el-checkbox-group>
              </div>
            </el-col>
          </el-col>
          <el-col
            class="detail-sub"
            :span="17"
          >
            <el-col
            v-for="(subItem, subIndex) in mandatory.tradePerfectScopeDetailList"
            :key="subIndex"
            >
              <el-col :span="3">
                <el-select
                  v-if="mandatory.canUpdate"
                  style="width:85px"
                  size="small"
                  filterable
                  v-model="subItem.brandCode"
                  @change="handleBrandChange(mandatory.tradePerfectScopeDetailList[subIndex])"
                  placeholder="品牌"
                >
                  <el-option
                    v-for="(brand, index) in customBrandList"
                    :key="index"
                    :label="brand.abiBrandDesc"
                    :value="brand.abiBrandCode"
                  ></el-option>
                </el-select>
                <div v-else class="detail-item-brand">{{ subItem.brandName }}</div>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-if="mandatory.canUpdate"
                  style="width:85px"
                  size="small"
                  filterable
                  v-model="subItem.subBrandCode"
                  placeholder="子品牌"
                  :disabled="!mandatory.canUpdate"
                  @change="everyCheckData()"
                >
                  <el-option
                    v-for="(brand, index) in getSubBrandList(subItem.brandCode)"
                    :key="index"
                    :label="brand.abiBrandDesc"
                    :value="brand.abiBrandCode"
                  ></el-option>
                </el-select>
                <div v-else class="detail-item-brand">{{ subItem.subBrandName }}</div>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="subItem.volume"
                  size="small"
                  placeholder="容量"
                  :disabled="!mandatory.canUpdate"
                  style="width:80px"
                >
                  <el-option
                    v-for="item in specList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="subItem.multiPackFlag"
                  size="small"
                  placeholder="是否多联包"
                  :disabled="!mandatory.canUpdate"
                  style="width:80px"
                  @change="flagChange($event, subItem)"
                >
                  <el-option
                    v-for="item in multiPackList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="subItem.multiPackSpec"
                  size="small"
                  placeholder="规格"
                  :disabled="!mandatory.canUpdate || !(Number(subItem.multiPackFlag))"
                  style="width:70px"
                  @change="getRowQty($event, subItem)"
                >
                  <el-option
                    v-for="item in multiPackSpecList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="subItem.minDisplayQty"
                  size="small"
                  placeholder="最小陈列件"
                  :disabled="!mandatory.canUpdate"
                  style="width:60px"
                  @change="everyCheckData($event, subItem)"
                >
                  <el-option
                    v-for="item in 30"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-col>
              <!-- 排面数 -->
              <el-col :span="2" style="text-align: center">
                {{ subItem.rowQty || '' }}
              </el-col>
              <el-col :span="4">
                <!-- bu  update时 -->
                <div v-if="employeeLevel > 50">
                  <!-- 新增的套餐可修改 -->
                  <div v-if="mandatory.canUpdate">
                    <el-button
                      :disabled="disabledBtn || isDetailPage"
                      v-if="subIndex === mandatory.tradePerfectScopeDetailList.length - 1"
                      type="primary"
                      plain
                      size="mini"
                      @click="handleAddSubRow(getIndex(index))"
                      >新增</el-button
                    >
                    <el-button
                      :disabled="disabledBtn || isDetailPage"
                      type="danger"
                      plain
                      size="mini"
                      @click="handleDeleteSubRow(getIndex(index), subIndex)"
                      >删除</el-button
                    >
                  </div>
                  <div v-if="!mandatory.canUpdate&&subIndex===0">
                    <el-button
                      :disabled="disabledBtn || isDetailPage"
                      type="danger"
                      plain
                      size="mini"
                      @click="handleDeleteRow(mandatory, getIndex(index))"
                      >删除套餐</el-button
                    >
                  </div>
                </div>

                <!-- region -->
                <div v-if="employeeLevel <= 50 && subIndex === 0">
                  <el-checkbox
                    v-model="mandatory.checked"
                    :disabled="isDetailPage"
                  ></el-checkbox>
                </div>
              </el-col>
            </el-col>
          </el-col>
        </el-row>
      </div>

      <div class="pagination">
        <el-pagination
          background
          :current-page.sync="pageInfo.currentPage"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="mandatoryItemList.length"
        >
        </el-pagination>
      </div>
    </div>

    <div v-else style="text-align:center">
      您暂未配置必备品套餐
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
export default {
  // 必备品相关
  name: 'perfect-theme-config-mandatory',
  props: {
    employeeLevel: {
      type: Number
    },
    brandInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 匹配的品牌
    customBrandList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 展示数据
    originInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 用以匹配的数据
    matchInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    regionListByBu: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedOrgCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      pageType: '',
      class: '',
      mandatoryItemList: [
        {
          canUpdate: true,
          checked: false,
          defineName: '',
          tradePerfectScopeDetailList: [
            {
              brandCode: '',
              subBrandCode: '',
              volume: '',
              minDisplayQty: '',
              multiPackFlag: '',
              multiPackSpec: '',
              rowQty: null
            }
          ],
          regionCodeList: [],
          checkAll: false
        }
      ],
      mandatoryItemListOrigin: [],
      showSubBrandList: [],
      // brandList: [],
      // subBrandList: [],
      multiPackList: [
        {
          key: '1',
          value: '是'
        },
        {
          key: '0',
          value: '否'
        }
      ],
      pageInfo: {
        currentPage: 1,
        pageSize: 5
      },
      disabledSelected: false,
      disabledBtn: false,
      checkInfoHint: '',
      checkedResult: false,
      packSpecList: []
    }
  },
  watch: {
    'selectedOrgCode' () {
      // console.log('watch selectedOrgCode')
      this.filterDataByRegion()
    }
  },
  computed: {
    ...mapState({
      specList: state => state.base.tradePerfectMandatorySpecsMap,
      multiPackSpecList: (state) => {
        return state.base.tradePerfectScopeDetailSpecMap
      }
    }),
    mandatoryItemListPagination () {
      if (!this.mandatoryItemList) return []
      const startIndex =
        this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      const endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      return this.mandatoryItemList.slice(startIndex, endIndex)
    },
    isDetailPage () {
      return this.class === 'detail'
    },
    isUpdate () {
      return this.pageType === 'update' || this.pageType === 'config'
    }
  },
  created () {
    this.pageType = this.$route.query.handleType
    this.class = this.$route.query.class
  },
  methods: {
    setData () {
      this.disabledSelected = this.employeeLevel <= 50
      this.disabledBtn = this.employeeLevel <= 50

      // 货架/冰柜必备品定义
      if (this.pageType === 'config') {
        // 新建
        if (this.originInfo.mandatoryScopeList) {
          this.mandatoryItemList = _.cloneDeep(
            this.originInfo.mandatoryScopeList
          )
        } else {
          this.mandatoryItemList = this.$options.data().mandatoryItemList
        }
        this.mandatoryItemList.map(item => {
          this.$set(item, 'checked', false)
          this.$set(item, 'regionCodeList', [])
        })
        this.mandatoryItemListOrigin = _.cloneDeep(this.mandatoryItemList)
        if (this.employeeLevel <= 50) {
          this.filterDataByRegion()
        }
      } else if (this.pageType === 'update') {
        // 修改
        if (this.employeeLevel <= 50) {
          this.mandatoryItemList =
            _.cloneDeep(this.originInfo.mandatoryScopeList) ||
            this.$options.data().mandatoryItemList
          let matchArr =
            _.cloneDeep(this.matchInfo.mandatoryScopeList) ||
            this.$options.data().mandatoryItemList

          console.log(111)
          console.log(this.matchInfo.mandatoryScopeList)
          console.log(this.$options.data().mandatoryItemList)

          this.mandatoryItemList.map((item, index) => {
            this.$set(item, 'checked', false)
            this.$set(item, 'regionCodeList', [])
            item.regionCodeList = item.regionCodes ? item.regionCodes.split(',') : []
          })
          // 当该任务是已配置，而非在修改里新增的配置时 设置checked=true
          if (!(this.originInfo.taskType && !this.matchInfo.taskType)) {
            if (this.mandatoryItemList.length && matchArr.length) {
              this.mandatoryItemList.forEach(item => {
                matchArr.forEach(subItem => {
                  if (item.defineName === subItem.defineName) {
                    this.$set(item, 'checked', true)
                    this.$set(item, 'regionCodeList', [])
                    item.regionCodeList = item.regionCodes ? item.regionCodes.split(',') : []
                    item.checked = true
                  }
                })
              })
            }
          }
        } else {
          this.mandatoryItemList =
            _.cloneDeep(this.matchInfo.mandatoryScopeList) ||
            this.$options.data().mandatoryItemList
          this.mandatoryItemList.map(item => {
            this.$set(item, 'regionCodeList', [])
            this.$set(item, 'checkAll', false)
            item.regionCodeList = item.regionCodes ? item.regionCodes.split(',') : []
          })
        }
      }
    },

    // region 新建时 根据所选区域判断是否展示数据
    filterDataByRegion () {
      if (this.$route.query.handleType === 'config') {
        if (!this.selectedOrgCode) {
          this.mandatoryItemList = []
          return
        }
        this.mandatoryItemList = this.mandatoryItemListOrigin.filter((item) => {
          return item.regionCodes ? item.regionCodes.indexOf(this.selectedOrgCode) > -1 : false
        })
      }
    },

    // 获取分页后 元素在数组中的实际index
    getIndex (index) {
      return (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize + index
    },
    // 新增套餐
    handleAddRow () {
      let obj = {
        checked: false,
        // defineName: '必备品套餐' + (this.mandatoryItemList.length > 0 ? (Number(this.mandatoryItemList[0].defineName.slice(5)) + 1) : 1),
        defineName: '必备品套餐' + (this.mandatoryItemList.length + 1),
        tradePerfectScopeDetailList: [
          {
            brandCode: '',
            subBrandCode: '',
            volume: '',
            minDisplayQty: '',
            multiPackFlag: '',
            multiPackSpec: '',
            rowQty: null
          }
        ],
        regionCodeList: [],
        checkAll: false
      }
      if (this.isUpdate) {
        obj.canUpdate = true
      }
      this.mandatoryItemList.unshift(obj)
    },
    // 新增子套餐
    handleAddSubRow (index) {
      let subIndex = this.mandatoryItemList[index].tradePerfectScopeDetailList.length
      this.$set(this.mandatoryItemList[index].tradePerfectScopeDetailList, subIndex, {
        brandCode: '',
        subBrandCode: '',
        volume: '',
        minDisplayQty: '',
        multiPackFlag: '',
        multiPackSpec: '',
        rowQty: null
      })
    },
    // 删除子套餐
    handleDeleteSubRow (index, subindex) {
      this.$confirm('是否确认删除该条配置', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.mandatoryItemList[index].tradePerfectScopeDetailList.length === 1) {
          this.mandatoryItemList.splice(index, 1)
        } else {
          this.mandatoryItemList[index].tradePerfectScopeDetailList.splice(subindex, 1)
        }
      }).catch(() => {})
    },
    // 删除套餐
    handleDeleteRow (mandatory, index) {
      this.$confirm('是否确认删除该套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.mandatoryItemList.splice(index, 1)
        })
        .catch(() => {})
    },

    handleReset () {
      this.setData()
    },
    // 更改主品牌 清空子品牌
    handleBrandChange (item) {
      item.subBrandCode = ''
      this.everyCheckData()
    },
    // 根据是否多联包展示对应规格
    flagChange (e, subItem) {
      if (e === '1') {
        // this.packSpecList = this.multiPackSpecList
        subItem.multiPackSpec = ''
      } else {
        // this.packSpecList = [{
        //   key: '1*1',
        //   value: '1*1'
        // }]
        subItem.multiPackSpec = '1*1'
      }
      this.getRowQty(e, subItem)
    },
    // 展示联动的子品牌列表
    getSubBrandList (parentBrandCode) {
      let arr = []
      if (this.customBrandList.length) {
        this.customBrandList.forEach(item => {
          if (parentBrandCode === item.abiBrandCode) {
            arr = item.subBrandList
          }
        })
      }
      return arr
    },

    // 必备品 每次改动的校验
    everyCheckData (e, subItem) {
      if (e) {
        this.getRowQty(e, subItem)
      }
      this.checkInfoHint = ''
      if (!this.checkNameData()) {
        this.$message.warning(`套餐类型名称 ${this.checkInfoHint} 重复`)
        return false
      }

      if (!this.checkInsideData()) {
        this.$message.warning(`套餐 ${this.checkInfoHint} 内部数据重复`)
        return false
      }

      // 套餐内每个数据都填完，才去校验套餐之间
      // ----------------------------
      let allList = Object.assign([], this.mandatoryItemList)
      let canCheck = true
      if (allList.length > 1) {
        allList.forEach(mandatory => {
          if (mandatory.tradePerfectScopeDetailList.length) {
            mandatory.tradePerfectScopeDetailList.forEach(item => {
              if (!item.brandCode || !item.subBrandCode || !item.minDisplayQty || !item.volume || !item.multiPackFlag || !item.multiPackSpec) {
                canCheck = false
              }
            })
          }
        })
      }
      // -----------------------------
      if (canCheck && !this.checkBrotherData()) {
        // this.$message.warning('套餐之间数据重复')
        this.$message.warning(`套餐 ${this.checkInfoHint} 之间数据重复`)
        return false
      }
      return true
    },

    // 套餐类型名称 name
    checkNameData () {
      let checkedResult = true
      let allList = Object.assign([], this.mandatoryItemList)
      let nameArr = []
      let sameObj = {}

      if (allList.length > 1) {
        allList.forEach(mandatory => {
          nameArr.push(mandatory.defineName)
        })
      }

      sameObj = this.sortCheckSame(nameArr)

      checkedResult = sameObj.checkedResult
      this.checkInfoHint = checkedResult ? '' : sameObj.hint

      return checkedResult
    },

    // 套餐内部校验 brand subBrand spec
    checkInsideData () {
      let checkedResult = true
      let allList = Object.assign([], this.mandatoryItemList)

      if (allList.length) {
        for (let i = 0; i < allList.length; i++) {
          // 每个套餐
          let itemArr = allList[i].tradePerfectScopeDetailList
          let itemName = allList[i].defineName
          let insideStrArr = []

          if (itemArr.length) {
            itemArr.forEach(itemInfo => {
              // 每个套餐内部
              if (itemInfo.brandCode && itemInfo.subBrandCode && itemInfo.volume) {
                let itemStr = itemInfo.brandCode + ',' + itemInfo.subBrandCode + ',' + itemInfo.volume + ',' + itemInfo.multiPackFlag + ',' + itemInfo.multiPackSpec
                insideStrArr.push(itemStr)
              }
            })
          }
          // insideStrArr 内部如 ["ISP,20AHME01,bigCan", "ISP,20AHME01,BBT"]
          checkedResult = this.sortCheckSame(insideStrArr).checkedResult
          if (!checkedResult) {
            this.checkInfoHint = itemName
            break
          }
        }
      }
      return checkedResult
    },

    // 套餐之间校验  brand subBrand spec qty
    checkBrotherData () {
      let checkedResult = true
      let allList = Object.assign([], this.mandatoryItemList)

      if (allList.length > 1) {
        let allStrList = []
        let itemNameList = []
        let sameObj = {}

        for (let i = 0; i < allList.length; i++) {
          // 每个套餐
          let itemArr = allList[i].tradePerfectScopeDetailList
          itemNameList.push(allList[i].defineName)

          let insideStrArr = []

          if (itemArr.length) {
            itemArr.forEach(itemInfo => {
              // 每个套餐内部
              let str = itemInfo.brandCode + ',' + itemInfo.subBrandCode + ',' + itemInfo.volume + ',' + itemInfo.minDisplayQty + ',' + itemInfo.multiPackFlag + ',' + itemInfo.multiPackSpec
              insideStrArr.push(str)
            })
          }

          // allSrtList 内部如 ["["20ABZY,20ABZY10,bigCan,3","20ACKF,20ACKF15,bigCan,3"]", "["20ABZY,20ABZY10,bigCan,3"]"]
          allStrList.push(JSON.stringify(insideStrArr.sort()))
        }

        sameObj = this.sortCheckSame(allStrList)
        checkedResult = sameObj.checkedResult
        if (!checkedResult) {
          let index1 = allStrList.indexOf(sameObj.hint)
          let index2 = allStrList.indexOf(sameObj.hint, (index1 + 1))
          this.checkInfoHint = itemNameList[index1] + '与' + itemNameList[index2]
        }
      }

      return checkedResult
    },

    // 排序查重
    sortCheckSame (checkArr) {
      let arr = Object.assign([], checkArr)
      let checkedResult = true
      let hint = ''

      if (arr.length) {
        let sortArr = arr.sort()
        for (let i = 0; i < sortArr.length; i++) {
          if (sortArr[i] === sortArr[i + 1]) {
            hint = sortArr[i]
            checkedResult = false
            break
          }
        }
      }

      // return checkedResult
      return { checkedResult, hint }
    },

    // 主组件校验
    checkData () {
      this.checkedResult = true
      let checkedResult = false

      // bu 字段不为空判断
      if (this.employeeLevel > 50) {
        let arr = []
        if (this.mandatoryItemList.length) {
          this.mandatoryItemList.forEach(mandatory => {
            if (mandatory.tradePerfectScopeDetailList.length) {
              mandatory.tradePerfectScopeDetailList.forEach(item => {
                arr.push(item)
              })
            }
          })
        }
        if (arr.length) {
          checkedResult = arr.every(item => {
            return Boolean(
              item.brandCode && item.subBrandCode && item.volume && item.minDisplayQty && item.multiPackFlag && item.multiPackSpec
            )
          })
        }
      }

      // bu 必备品内部数据校验
      if (checkedResult && this.employeeLevel > 50) {
        checkedResult = this.everyCheckData()
      }

      // region 有勾选
      if (this.employeeLevel <= 50) {
        checkedResult = false
        if (this.mandatoryItemList.length) {
          checkedResult = this.mandatoryItemList.some(item => {
            return item.checked
          })
        }
      }

      this.checkedResult = checkedResult
    },

    checkName (e) {
      if (e && !e.target.value) {
        this.$message.warning('必备品/排面数套餐名称不能为空')
      }
    },

    // 计算排面数
    getRowQty (e, subItem) {
      subItem.rowQty = null
      if (subItem.multiPackSpec && subItem.minDisplayQty) {
        let specList = subItem.multiPackSpec.split('*')
        specList.sort((a, b) => {
          return Number(b) - Number(a)
        })
        subItem.rowQty = Number(specList[0]) * subItem.minDisplayQty
      }
    },

    // 全选/取消全选
    handleCheckAllChange (e, item) {
      if (e) {
        this.regionListByBu.forEach(list => {
          item.regionCodeList.push(list.orgCode)
        })
      } else {
        item.regionCodeList = []
      }
    },

    handleRegionChange (e, item) {
      item.checkAll = this.regionListByBu.every(item => {
        return e.indexOf(item.orgCode) !== -1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.require {
  color: red;
}
.wrapper {
  position: relative;
  background-color: #fff;
  // height: 800px;
  .content {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    color: #333;
    transition: height 0.5s;
    .title {
      display: flex;
      flex: none;
      width: 100%;
      // flex-basis: 14%;
      font-size: 16px;
      font-weight: 600;
      justify-content: space-between;
      div {
        // width: 100%;
        text-align: right;
      }
      .el-button {
        display: inline-block;
      }
    }
  }
  .info {
    position: relative;
    // min-height: 700px;
    .header {
      line-height: 40px;
      border-radius: 5px;
      background: #eee;
    }
    .el-col {
      text-align: center;
    }
    .detail {
      flex-wrap: wrap;
      // min-height: 120px;
      // line-height: 120px;
      padding: 30px 0;
      .detail-sub {
        line-height: 50px;
      }
      .region-wrapper {
        line-height:30px;
        text-align:left;
        padding: 10px 0;
      }
      .design-thumbnail {
        width: 100%;
        height: 100%;
        cursor: pointer;
        .design-thumbnail-column {
          display: inline-block;
        }
        .design-thumbnail-row {
          box-sizing: border-box;
          width: 25px;
          height: 25px;
          border: 1px solid #c0c4cc;
          border-radius: 3px;
        }
      }
      .design {
        text-align: center;
        .design-img {
          display: flex;
          flex-wrap: wrap;
          height: 100px;
          width: 100px;
          margin: 0 auto;
          // border: 1px solid #C0C4CC;
          border-radius: 8px;
          div {
            box-sizing: border-box;
            display: inline-block;
            border: 1px solid #c0c4cc;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .card-wraper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }
  .box-card {
    // width: 700px;
    pointer-events: auto;
    z-index: 2;
    .card-header {
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      span {
        display: inline-block;
        width: 50%;
      }
    }
    .card-select {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      padding-bottom: 10px;
      // min-width: 350px;
    }
  }
  .card-item {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100px;
    height: 80px;
    margin: 10px auto 0;
    text-align: center;
    color: #fff;
    border: 1px solid #c0c4cc;
    border-radius: 10px;
  }
  .card-operte {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  .pagination {
    text-align: center;
    padding: 20px 0;
  }
}
.el-select {
  width: 120px;
}
.detail-item-brand {
  height: 32px;
  line-height: 32px;
  margin-top: 8.5px;
  background-color: #F5F7FA;
  border-radius: 4px;
  border: 1px solid #E4E7ED;
  width: 80px;
  color: #C0C4CC;
  font-size: 13px;
  box-sizing: border-box;
  padding: 0 5px;
  text-align: left;
  overflow: hidden;
  cursor: not-allowed;
}
</style>
